import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const attemptReturnPickupRefund = {
  name: "attemptReturnPickupRefund" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({}),
};
